<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} lịch khám
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <b-row>
                <!-- <b-col md="4">
                  <el-select
                    v-model="mData.dataDefault.loai_dich"
                    placeholder="Loại lịch khám"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listLoaiDich"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>-->
              </b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <!-- <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>-->
              <el-button @click="fn_handle('create')" type="info" plain>Đặt lịch khám</el-button>
              <!-- <el-button @click="fn_handle('goBack')" type="info" plain>{{aLang.c_back}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          style="width: 100%"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="NUM_ORDER"
            label="Lượt khám"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="HOSPITAL_NAME"
            label="Bệnh viện"
            width="auto"
            min-width="300"
          ></el-table-column>
          <el-table-column
            prop="PATIENT_TYPE_NAME"
            label="Loại khám"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="ROOM_NAME"
            label="Phòng khám"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="SERVICE_NAME"
            label="Dịch vụ"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="REGISTER_DATE"
            label="Ngày khám"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <span
                class="text-primary pl-2 pr-2 bold"
                v-if="fn_checkQuaHan(scope.row.IS_ACTIVE, scope.row.REGISTER_DATE) == 'dungHan'"
              >{{scope.row.REGISTER_STT_ID && (scope.row.REGISTER_STT_ID == 5 || scope.row.REGISTER_STT_ID == 6) ? (scope.row.REGISTER_STT_ID == 5 ? 'Thanh toán thành công' : 'Thanh toán thất bại') : (scope.row.PRICE == 0 || scope.row.PRICE == 0.0 || scope.row.PRICE == null ? 'Thanh toán thành công' : 'Chưa thanh toán')}}</span>

              <span
                class="text-secondary pl-2 pr-2 bold"
                v-if="fn_checkQuaHan(scope.row.IS_ACTIVE, scope.row.REGISTER_DATE) == 'quaHan'"
              >Quá hạn</span>

              <span
                class="text-warning pl-2 pr-2 bold"
                v-if="fn_checkQuaHan(scope.row.IS_ACTIVE, scope.row.REGISTER_DATE) == 'daHuy'"
              >Đã hủy</span>

              <!-- <el-button
                size="mini"
                @click="fn_handle('detail', null, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>-->

              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('Admin,Officer')"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- modal khai bao dich-->
    <el-dialog
      :close-on-click-modal="false"
      title="lịch khám"
      :visible.sync="mData.dialog.KhamDich.visible"
      width="70%"
      top="51px"
    >
      <div class="card-body scroll-y-80vh">
        <b-embed type="iframe" aspect="16by9" :src="mData.dialog.KhamDich.url" allowfullscreen></b-embed>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DangKyKhamModel from "./DangKyKhamModel";
import DangKyKhamApi from "../../../moduleApi/DangKyKhamApi";
import DkkApi from "../../../moduleApi/DkkApi";
import * as moment from "moment";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DangKyKham", //requied
        tableRules: MethodService.copyObject(DangKyKhamModel.tableRules),
        dataDefault: {
          loai_dich: "1",
          listLoaiDich: [
            {
              code: "1",
              text: "Dịch Covid-19"
            }
          ],
          inforNguoiDan: {},
          urlSurvey: ""
        },
        dialog: {
          KhamDich: {
            visible: false,
            index: 0,
            viewMode: "create",
            url: ""
          }
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      const currentUser = MethodService.getCurrentUser();
      let body = {
        "ApiData": {
            "PEOPLE_CODE__EXACT": currentUser.account,
            "ORDER_FIELD": "",
            "ORDER_DIRECTION": "",
            "IS_ACTIVE": 1
        }
    }
      let res = await DkkApi.GetListBooking(body);
      res.data.Data = res.data.Data.filter(booking => {
        return booking.NUM_ORDER > 0;
      });
      this.mData.tableRules.data = res.data.Data.sort(function (a,b) {return new Date(b.REGISTER_DATE).getTime() - new Date(a.REGISTER_DATE).getTime()});
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await DangKyKhamApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await DangKyKhamApi.disable(id, disable);
      this.fn_initTable();
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate2(
        cellValue,
        "date",
        "YYYY:MM:DDTHH:mm:ss.SSSZZ"
      );
    },

    async fn_initData() {},

    fn_checkQuaHan(is_active, register_date) {
      let day = moment(register_date, "YYYYMMDDHHmmss");
      if (is_active) {
        let res = MethodService.soSanhVoiNgayHomNay(day);
        // console.log(day.format("YYYYMMDDHHmmss"),res);
        if (res) {
          return "dungHan";
        } else {
          return "quaHan";
        }
      } else {
        return "daHuy";
      }
    },
    async fn_huyLich(id) {
      let res = await DangKyKhamApi.update({ id: id, is_active: false });
      this.fn_initTable();
    }
  },

  //run after render view
  created() {
    // this.fn_hashUrl();
    // this.fn_initData();
  },
  mounted() {
    console.log("vào đây không");
    this.fn_initTable();
  }
};
</script>

<style lang="scss" scoped>
::v-deep.el-table {
  .el-table_1_column_2 {
    width: 200px!important;
  }
}
</style>
